import { Checkbox } from '../NarusMaterial'

import { makeAutobindedInput } from './FormBuilder'

export const CheckboxField = props => {
  const { onChange, value, label, checkLabel, ...rest } = props
  return (
    <Checkbox
      label={label || checkLabel}
      onChange={val => onChange && onChange(val)}
      value={value}
      {...rest}
    />
  )
}

export const CheckboxInput = makeAutobindedInput(CheckboxField)
